import axios from "@/axios/axios-api";

export default {
  async getUsuariosEmisoresByFinanciadorId(_, payload) {
    try {
      const response = await axios.get(
        `api/usuariosEmisores/usuarios-emisores/${payload}`
      );
      return response?.data;
    } catch (error) {
      console.error("Error al traer usuarios emisores", error);
    }
  },
  async getUsuarioEmisorByFinanciadorId(_, payload) {
    try {
      const response = await axios.get(
        `api/usuariosEmisores/usuario-emisor/${payload}`
      );
      return response?.data;
    } catch (error) {
      console.error("Error al traer usuarios emisores", error);
    }
  },
  async searchPrestadorByCuit(_, payload) {
    try {
      let url = `api/usuariosEmisores/search-prestador?cuit=${payload.cuit}&financiadorId=${payload.financiadorId}`;

      if (payload.preId != null) {
        url += `&preId=${payload.preId}`;
      }

      const response = await axios.get(url);
      return response;

    } catch (error) {
      console.error("Error al traer usuarios emisores", error);
    }
  },
  async validatePrestadorByCuil(_, payload) {
    try {
      const response = await axios.post("api/SISAWs/obtener-por-cuil", {
        Cuil: payload.cuil,
      });
      return response;
    } catch (error) {
      console.error("Error al validar prestador por CUIL", error);
    }
  },
  async saveUsuarioEmisor(_, payload) {
    try {
      const response = await axios.post(
        "api/usuariosEmisores/usuarios-emisores",
        payload
      );
      return response;
    } catch (error) {
      console.error("Error al guardar cambios financiador", error);
    }
  },
  async deleteUsuarioEmisor(_, payload) {
    try {
      let response;
      
      // Si viene un array de preXFinIds, usar el endpoint múltiple
      if (payload.preXFinIds && Array.isArray(payload.preXFinIds)) {
        const preXFinIdsParam = payload.preXFinIds.map(id => `preXFinIds=${id}`).join('&');
        response = await axios.delete(
          `api/usuariosEmisores/usuarios-emisores-multiple?preId=${payload.preId}&${preXFinIdsParam}&usuarioId=${payload.usuarioId}`
        );
      } else {
        // Mantener compatibilidad con el endpoint original para un solo preXFinId
        response = await axios.delete(
          `api/usuariosEmisores/usuarios-emisores?preId=${payload.preId}&preXFinId=${payload.preXFinId}&usuarioId=${payload.usuarioId}`
        );
      }

      if (response.status == 204) return null;
      else return response;
    } catch (error) {
      console.error("Error al eliminar usuarios emisores", error);
    }
  },
  async changeUserEnabledStatus(_, payload) {
    try {
      // Si payload es un array, construir la URL con múltiples preXFinIds
      let url;
      if (Array.isArray(payload)) {
        const preXFinIdsParam = payload.map(id => `preXFinIds=${id}`).join('&');
        url = `api/usuariosEmisores/change-user-status?${preXFinIdsParam}`;
      } else {
        // Mantener compatibilidad con un solo preXFinId
        url = `api/usuariosEmisores/change-user-status?preXFinIds=${payload}`;
      }
      
      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      console.error("Error al cambiar el estado del usuario", error);
    }
  },
  async saveImportacionMedicosEmisores(context, payload) {
    try {
      const response = await axios.post(
        "api/importaciones/save-importacion-medicos-emisores", payload
      );
      return response;
    } catch (error) {
      console.error("Error importar medicos emisores", error);
    }
  },
};
